/**
 * Moved to `shared/src/review/topic-supporting-pages.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  AMBIENT_ANCHOR_MIN_SITE_PREVALENCE,
  ANCHOR_SLUG_COVERAGE_FLOOR,
  FOCAL_ANCHOR_COMPARISON_MIN_RELATIVE_WEIGHT,
  FOCAL_ANCHOR_MAX_TOPICS,
  FOCAL_ANCHOR_MIN_RELATIVE_WEIGHT,
  FOCAL_ANCHOR_RESCUE_MIN_LABEL_IN_SLUG,
  FOCAL_ANCHOR_SLUG_SPECIFIC_MIN_RELATIVE_WEIGHT,
  SUPPORTING_PAGE_INITIAL_VISIBLE_COUNT,
  SUPPORTING_PAGE_MIN_RELEVANCE_SCORE,
  SUPPORTING_PAGE_USER_INITIAL_VISIBLE_COUNT,
  anchorSlugCoverage,
  buildPageTopicLabelsBySlug,
  compareSupportingPagesByRelevance,
  computeAnchorSitePrevalence,
  extractSupportingPagesFromDiagnostic,
  extractTopicTaggedPagesFromDiagnostic,
  filterCompetingEntityRowsFromRivalColumns,
  filterHubRowsFromOwnColumns,
  filterRowsByFocalAnchorTopics,
  filterRowsByFocalEntity,
  filterSupportingPagesByRelevance,
  filterYourMatchPoolForCompetitorRow,
  formatSupportingPagePath,
  formatSupportingPageTraffic,
  getFocalAnchorTopicSlugs,
  getTopTopicsForSupportingPages,
  isComparisonLikeUrlForTopicAnchors,
  isHubUrl,
  mergeTopicTaggedPagesByUrl,
  normalizeTopicSlug,
  normalizeUrlForCompare,
  passesSupportingPageRelevanceThreshold,
  resolveParentTopicSlug,
  rowNamesCompetingEntity,
  rowOverlapsFocalAnchorTopics,
  sameWordFamily,
  slugContentTokens,
  stemTopicToken,
  tokensCoverTargets,
  uniqueParentDiagnosticSlugs
} from '@taptimize/shared/dist/review/topic-supporting-pages';
export type {
  DomainTopicUrlRow,
  ExtractTopicTaggedPagesOptions,
  FocalAnchorOptions,
  TopicPageChip,
  TopicPageRole,
  TopicParentLookup,
  TopicSlugLabel,
  TopicSupportingPage
} from '@taptimize/shared/dist/review/topic-supporting-pages';
